import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Icon, Button, CheckBox, TemplateTable, MenuBar, StandaloneIcon, TruncateToolTip, Helper } from 'Components';
import moneyFormatter from 'helpers/money-formatter';
import needDollarSign from 'constants/need-currency';
import menuOptions from 'constants/menuOptions';
import rowRules from 'helpers/rowRules';
import { icons } from 'constants/invoicesKeyPairs';
import InvoicesSubTemplate from './InvoicesSubTemplate';
import './InvoicesTemplate.css';

const formatRow = (key, value = '') => {
  if (needDollarSign.includes(key)) {
    return moneyFormatter(value);
  }

  if (key === 'TaskOrderNumber') {
    if (value === i18n.t('common:Not Specified')) {
      return '';
    }
  }

  if (key === 'POAFENumber') {
    let POAFENumber = value;
    if (value.split(',').includes(i18n.t('common:Not Specified'))) {
      POAFENumber = value.split(',').filter(item => item !== i18n.t('common:Not Specified')).join(',');
    }

    return (<TruncateToolTip text={POAFENumber} delimiter="," />);
  }

  return value;
};

const InvoicesTemplate = (props) => {
  const isChecked = props.selectedInvoices.includes(props.InvoiceNumber);
  const menuBarIcons = [...icons];
  const isPaid = props.AmountRemaining <= 0 || Number(props.IsPayable) === 0;
  if (isPaid) menuBarIcons.pop();

  return (
    <Fragment>
      <tr onClick={e => props.onMoreVertClick(e, props.tableIndex)} className={`invoices-list__template ${isChecked ? 'invoices-list__template--checked' : ''}`}>
        <td>
          <Helper text={i18n.t('tutorials:invoices.2')}>
            <Button onClick={e => props.onTrExpand(e, props.tableIndex)}>
              <Icon icon={props.Expanded ? 'remove' : 'add'} />
            </Button>
          </Helper>
        </td>
        <td className={isPaid ? 'invoices-list__template__paid__checkbox--hide' : ''}>
          <Helper text={i18n.t('tutorials:invoices.1')}>
            <CheckBox
              checked={isChecked}
              onClick={e => props.onCheckBoxClick(e, props.tableIndex)}
            />
          </Helper>
        </td>
        {
          props.keys.map(key => (
            <td key={key}>
              {formatRow(key, props[key])}
            </td>
            ))
        }

        <td className="template-table__td--menu-slot">
          <MenuBar
            tableIndex={props.tableIndex}
            onClick={props.onMenuClick}
            show={props.tableIndex === props.menuRow}
            icons={menuOptions.filter(option => rowRules.invoice(option, props))}
          />
        </td>
        <td className="template-table__td--menu-icon">
          <Helper text={i18n.t('tutorials:invoices.5')} placement="bottom-left">
            <StandaloneIcon
              onClick={(e) => {
                e.preventDefault();
                props.onMoreVertClick(e, props.tableIndex);
              }}
              icon="more_vert"
              hasNoBackground
            />
          </Helper>
        </td>
      </tr>

      {
        props.Expanded &&
        <tr className="invoices-list__template-expanded__tr">
          <td colSpan="14" className="invoices-list__template-expanded__td">
            <div className="invoices-list__template-expanded__table-wrapper">
              <TemplateTable
                keys={props.invoiceJobs.keys}
                keyPairs={props.invoiceJobs.keyPairs}
                data={props.data[props.tableIndex].Jobs}
                template={InvoicesSubTemplate}
                viewCode={props.invoiceJobs.viewCode}
                setAppState={props.setAppState}
                isDraggable
                onSettingClick={() => props.setAppState({
                  settingTableCode: props.invoiceJobs.viewCode,
                })}
                hasSettings
                isLoading={props.data[props.tableIndex].isJobsTableLoading}
              />
            </div>
          </td>
        </tr>
      }
    </Fragment>
  );
};

InvoicesTemplate.propTypes = {
  menuRow: PropTypes.number,
  Expanded: PropTypes.bool,
  tableIndex: PropTypes.number,
  invoiceJobs: PropTypes.shape({
    keys: PropTypes.arrayOf(PropTypes.string),
    keyPairs: PropTypes.shape({}),
    viewCode: PropTypes.string,
  }),
  setAppState: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  keys: PropTypes.arrayOf(PropTypes.string),
  AmountRemaining: PropTypes.number,
  selectedInvoices: PropTypes.arrayOf(PropTypes.string),
  InvoiceNumber: PropTypes.string,
  onCheckBoxClick: PropTypes.func,
  onMenuClick: PropTypes.func,
  onTrExpand: PropTypes.func,
  onMoreVertClick: PropTypes.func,
  IsPayable: PropTypes.string,
};

export default InvoicesTemplate;



// WEBPACK FOOTER //
// ./src/containers/Invoices/InvoicesList/InvoicesTemplate/InvoicesTemplate.jsx